// Module
var code = "<p>Continue making payments through another method until you receive confirmation that Direct Debit will extract your next payment.</p> ";
// Exports
export default code;